import { defineMessages } from 'react-intl';

export const costEstimationItemsTableMessageDefinitions = defineMessages({
  referenceNumber: {
    id: 'estimationDetail.costEstimationItemsTable.referenceNumber',
    defaultMessage: '#',
  },
  subtotal: {
    id: 'estimationDetail.costEstimationItemsTable.subtotal',
    defaultMessage: 'Subtotal',
  },
  detailsButton: {
    id: 'estimationDetail.costEstimationItemsTable.detailsButton',
    defaultMessage: 'Details',
  },
  assumptionsButton: {
    id: 'estimationDetail.costEstimationItemsTable.assumptionsButton',
    defaultMessage: 'Assumptions',
  },
  commentsButton: {
    id: 'estimationDetail.costEstimationItemsTable.commentsButton',
    defaultMessage: 'Comments',
  },
  addEstimationItemButton: {
    id: 'estimationDetail.costEstimationItemsTable.addEstimationItemButton',
    defaultMessage: 'Add Cost',
  },
  emptyTableGroupName: {
    id: 'estimationDetail.costEstimationItemsTable.emptyTableGroupName',
    defaultMessage: 'Cost Name',
  },
  emptyTableText: {
    id: 'estimationDetail.costEstimationItemsTable.emptyTableText',
    defaultMessage: 'Currently there are no sub-costs for this cost.',
  },
  included: {
    id: 'estimationDetail.costEstimationItemsTable.included',
    defaultMessage: 'Included',
  },
});
